import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useWardrobeList = ({ search, page }) => {
  const filter = {
    filter: { searchTerm: search },
    paging: { pageIndex: page },
  };

  // If page = null, then remove paging
  if (page === null) {
    delete filter.paging;
  }

  return useQuery({
    queryKey: ["wardrobeListState", filter],
    queryFn: async () =>
      callApi({
        path: "wardrobelist",
        command: "",
        data: JSON.stringify({ list: filter }),
      }),
    placeholderData: keepPreviousData,
    staleTime: 5000,
  });
};
